import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';

import {
  TRANSLATION_GROUP_HEADER,
  TRANSLATION_SUPERVISION_NOTIFICATION_GROUP_HEADER,
} from './constants';
import { getSupervisionNotificationTranslationKeys, getTranslationKeys } from './translations';

export class HeaderModule extends AppModule {
  addRoutes(): void {}

  addMenu(): void {}

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_HEADER, getTranslationKeys);
    mapper.addTranslationsMap(TRANSLATION_SUPERVISION_NOTIFICATION_GROUP_HEADER, getSupervisionNotificationTranslationKeys);
  }
}
